import { ReactComponent as ZoomOut } from '@public/icons/zoom-out.svg';
import Icon from '../atoms/Icon';

const IconZoomOut = (props) => <Icon as={ZoomOut} {...props} />;

IconZoomOut.propTypes = Icon.propTypes;

export default IconZoomOut;
